import { useNavigate } from 'react-router-dom';

export default function BottomNav({ active }) {
  const navigate = useNavigate();

  const tabs = [
    { key: 'home', label: 'Home', path: '/dashboard' },
    { key: 'actions', label: 'Actions', path: '/actions' },
    { key: 'visibility', label: 'Recs', path: '/visibility' },
    { key: 'content', label: 'Content', path: '/content' },
    { key: 'profile', label: 'Profile', path: '/profile' },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50"
      style={{
        backgroundColor: '#EDE8DF',
        borderTop: '1px solid #D4C9B8',
        height: 56,
      }}
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around h-full max-w-lg mx-auto">
        {tabs.map(tab => {
          const isActive = active === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center gap-1 transition-colors"
              style={{ minWidth: 48 }}
              data-testid={`nav-${tab.key}`}
            >
              <span
                className="font-medium"
                style={{
                  color: isActive ? '#3C3226' : '#8C7E6E',
                  fontSize: '10px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  fontFamily: "'DM Sans', sans-serif",
                }}
              >
                {tab.label}
              </span>
              {isActive && (
                <span
                  className="block rounded-full"
                  style={{
                    width: 4,
                    height: 4,
                    backgroundColor: '#B8985A',
                  }}
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
